import { makeAutoObservable } from 'mobx';

class WorkspaceStore {
  anyWorkspaceChecked = false;

  constructor() {
    makeAutoObservable(this);
  }

  setAnyWorkspaceChecked = (anyWorkspaceChecked: boolean) => {
    this.anyWorkspaceChecked = anyWorkspaceChecked;
  }
}

export const workspaceStore = new WorkspaceStore();
